import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mic } from "lucide-react";
import api from "@/lib/api";

export default function LiveBanner() {
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const poll = () => api.get("/live/status").then((r) => setStatus(r.data)).catch(() => {});
    poll();
    const t = setInterval(poll, 10000);
    return () => clearInterval(t);
  }, []);
  if (!status?.active) return null;
  return (
    <button
      onClick={() => navigate("/live")}
      data-testid="live-banner"
      className="w-full flex items-center justify-center gap-3 py-2.5 bg-[#FF3B30] text-white text-sm font-bold hover:bg-[#e0342a] transition-colors"
    >
      <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-white live-dot" /> LIVE NOW</span>
      <Mic className="w-4 h-4" />
      <span className="truncate">{status.title} — hosted by {status.host_name}. Tap to tune in →</span>
    </button>
  );
}
